<div class="col-md-4 col-md-offset-4 col-xs-12">
  <div [formGroup]="loginForm" class="card">      
        <div class="card-header text-center">
          <h4 class="card-title">
            Login
          </h4>
        </div>
        <div class="card-content">
            <div class="form-group" [ngClass]="{ 'has-error': email?.touched && email?.invalid }" >
                <label class="control-label">Email Address</label>
                <input class="form-control"
                        formControlName="email"
                        name="email"
                        type="email"
                        email="true"
                        required="true"
                        autocomplete="username"                                               
                />
                <div class="text-danger" *ngIf="email?.touched && email?.invalid">
                  <div *ngIf="email?.errors?.['required']">Email is required.</div>
                  <div *ngIf="email?.errors?.['email']">Enter a valid email address.</div>
                </div>
            </div>
            <div class="form-group" [ngClass]="{ 'has-error': password?.touched && password?.invalid }">
                <label class="control-label">Password</label>
                <input class="form-control"
                        formControlName="password"
                        name="password"
                        autocomplete="current-password"
                        type="password"
                        required="true"                        
                  />
                  <div class="text-danger"  *ngIf="password?.touched && password?.invalid">
                    <div *ngIf="password?.errors?.['required']">Password is required.</div>                    
                  </div>
            </div>            
        </div>
        <div class="card-footer text-center">
        <button (click)="login()" class="btn btn-info btn-fill btn-wd">Login</button>
        </div>      
  </div>
</div>